/* eslint camelcase: 0 */
import { toMediaProps } from './media'
import { Download, DownloadRequest } from '@/infrastructure/network/Monitaro/schema/models'
import { IDownloadProps, EmptyDownloadPropsFactory } from '@/entities/Download'

export const toDownloadProps = (props: Download | null | undefined): IDownloadProps => {
  if (!props) {
    return EmptyDownloadPropsFactory()
  }

  const { id, creator, media, name, code, size, category, status, created_at, updated_at } = props

  return EmptyDownloadPropsFactory({
    id,
    creator,
    media: toMediaProps(media),
    name,
    code,
    size,
    category,
    status,
    createdAt: created_at,
    updatedAt: updated_at
  })
}

export const toDownloadRequest = (props: IDownloadProps): DownloadRequest => {
  const { code, category } = props
  return {
    code: code!,
    category: category!
  }
}
